import { Specialist } from "../types/specialist";
import { get } from "./fetch.core";

async function listSpecialists(type?: string) {
  const res = await get<Specialist[]>(`/admin/specialist/list?type=${type ?? ""}`);
  return res.data;
}

async function getSpecialist(id: string) {
  const res = await get<Specialist>(`/admin/specialist/get?id=${id}`);
  return res.data;
}

const obj = {
  listSpecialists,
  getSpecialist,
};

export default obj;
